<div class="card-header" #topPage id="toppage">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'answersheet-detail.select_language' | translate }}</mat-label>
    <mat-select [(value)]="selectedLocale" (closed)="onChange()">
      <mat-option
        *ngFor="let locale of locales; index as i"
        [value]="locale"
      >
        {{ helper.parseLanguage(locale) | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button
    [attr.id]="'btnToggleCollapse'"
    (click)="helper.toggleSubject(isCollapseSubject)"
    color="primary"
    data-html="true"
    data-toggle="tooltip"
    mat-button
    title="{{ 'answersheet-detail.answersheet_show_and_hide' | translate }}"
    type="button"
  >
    <fa-icon *ngIf="(isCollapse$ | async); else elseDetailsBlock" [icon]="faChevronUp"></fa-icon>
    <ng-template #elseDetailsBlock>
      <fa-icon [icon]="faChevronDown"></fa-icon>
    </ng-template>
    {{ 'answersheet-detail.lesson_elements' | translate }}
  </button>
  <button *ngIf="intervention?.attributes?.small_layout === 1" (click)="toggleSmallLayout()" mat-button>
    <div *ngIf="(isSmallLayout$ | async) === false; then thenMobileView else elseNormalView"></div>
    <ng-template #thenMobileView>
      <fa-icon [icon]="faEye"></fa-icon>
      {{ 'answersheet-detail.toggle_small_layout' | translate }}
    </ng-template>
    <ng-template #elseNormalView>
      <fa-icon [icon]="faEye"></fa-icon>
      {{ 'answersheet-detail.toggle_normal_layout' | translate }}
    </ng-template>
  </button>
</div>
<div [hidden]="isCollapse$ | async">
  <div [ngStyle]="getBackgroundStyle()" [ngClass]="{ smallLayout: (isSmallLayout$ | async)}" class="mx-auto card-body">
    <div class="mb-3">
      <ng-template #progressBarContainer></ng-template>
    </div>

    <ng-template #elementsContainer> </ng-template>
    <ion-button
      *ngIf="(currentPageNumber !== 0) && (pageIteration.length > 0) && hasEvaluatedPage('previous')"
      [attr.id]="'btnPreviousTopPage'"
      (click)="showTopPage(currentPageNumber - 1)"
      class="page-buttons"
      slot="start"
    >
      <ion-icon name="arrow-back"></ion-icon>
      {{ 'lesson-preview.button_previous_page' | translate }}
    </ion-button>

    <ion-button
      *ngIf="(currentPageNumber < pageIteration.length) && (pageIteration.length > 0) && hasEvaluatedPage('next')"
      [attr.id]="'btnNextTopPage'"
      (click)="showTopPage(currentPageNumber + 1)"
      class="page-buttons"
      slot="end"
    >
      {{ 'lesson-preview.button_next_page' | translate }}
      <ion-icon name="arrow-forward"></ion-icon>
    </ion-button>

    <div class="align-self-center">
      <div *ngIf="pageIteration.length > 0">
        <small>{{ 'lesson-preview.lesson_page' | translate }} - {{ getPageNumber() }}</small>
      </div>
    </div>
  </div>
</div>
